
    import { Options, Vue } from 'vue-class-component';
    import Sidebar from '@/components/Sidebar.vue'; // @ is an alias to /src
    import TicketBooking from '../components/BookingProcedures/TicketBooking.vue'
    import MobileSidebar from '../components/MobileSidebar.vue';
    import FavouriteFilters from '../components/Dashboard/FavouriteFilters/FavouritesCompanyFilters.vue'

    @Options({
        components: {
            Sidebar,
            TicketBooking,
            MobileSidebar,
            FavouriteFilters
        },

        data() {
            return {
                ticketId: ""
            }
        },

        updated() {
        
            let uri = window.location.search.substring(1); 
            let params = new URLSearchParams(uri);
            let ticketId = params.get("ticket");

            this.ticketId = ticketId
        },
    })
    export default class FavouriteCompanyTickets extends Vue {

    }
